import template from 'lodash.template';

const mustacheFactory = (replacements) => (string) => template(string, { interpolate: /{{([\s\S]+?)}}/g })(replacements);

const getCouponMustache = ({
  code, range, start, end,
} = {}) => mustacheFactory({
  code: `<b class="accent-text">${code}</b>`,
  range,
  start,
  end,
});

const getBrandMustache = ({
  totalProducts, brandName,
} = {}) => mustacheFactory({
  totalProducts: `${totalProducts}`,
  brandName,
});

const formatHTMLCodes = (string) => string.replace(/&#8209;/g, '-');

export {
  mustacheFactory,
  getCouponMustache,
  getBrandMustache,
  formatHTMLCodes,
};
